import React, { Component } from "react";
import {
    Row,
    Col,
} from "antd";
import { backendGet } from "../../../../helpers/callBackend";

class AccountDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            accountNumber: "",
            routingNumber: "",
        };
    };

    componentDidMount = () => {
        backendGet(
            this,
            "/api/payments/counterparty/detokenize/",
            { params: { counterparty_id: this.props.recipientId } },
            "",
            (s, d) => {
                s["accountNumber"] = d["account_number"];
                s["routingNumber"] = d["routing_number"];
                return s;
            }
        );
    }

    render() {
        return (
            <>
                <Row gutter={16}>
                    <Col span={12} style={{ textAlign: "left" }}>
                        Account Number
                    </Col>
                    <Col span={12} style={{ textAlign: "right" }}>
                        <p>{this.state.accountNumber}</p>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={12} style={{ textAlign: "left" }}>
                        Routing Number
                    </Col>
                    <Col span={12} style={{ textAlign: "right" }}>
                        <p>{this.state.routingNumber}</p>
                    </Col>
                </Row>
            </>
        );
    }
}

export default AccountDetails;
